const initialState = {
  data: {},
  error: false,
  currentStep: 1
};

export default function(state = initialState, action) {
  switch (action.type) {
    case 'NEXT_STEP': {
      return {
        ...state,
        currentStep: action.payload,
        error: ''
      };
    }
    case 'SET_ERROR': {
      return {
        ...state,
        error: action.payload,
      };
    }
    case 'SET_DATA': {
      return {
        ...state,
        data: action.payload,
      };
    }
    default:
      return state;
  }
}
